import { render, staticRenderFns } from "./Participate.vue?vue&type=template&id=5ed5d0ce&scoped=true"
import script from "./Participate.vue?vue&type=script&lang=js"
export * from "./Participate.vue?vue&type=script&lang=js"
import style0 from "./Participate.vue?vue&type=style&index=0&id=5ed5d0ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed5d0ce",
  null
  
)

export default component.exports